module.exports = __webpack_public_path__ + "static/media/icon_scan_project.82abcdf1.svg";